<template>
  <div class="totals-wrapper wrapper-1">
    <span class="totals">
      <span>{{ $t('Total Files') }}: {{ totalFiles }}</span> <span>|</span> <span>{{ $t('Size') }}: {{ totalSize }}</span>
    </span>
  </div>
</template>

<script>
import { bytesToSize } from '@/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'Totals',
props: {
  filesData: {
    type: Array,
    default: () => [],
  },
},
  computed: {
    ...mapGetters(['getSessionData']),
    totalSize() {
      const total = this.filesData.reduce(
        (acc, file) => acc + file.data.size,
        0
      )

      return bytesToSize(total)
    },
    totalFiles() {
      return this.filesData.length
    },
  },
}
</script>

<style scoped lang="scss">
.totals-wrapper {
  padding: 8px 12px;
  font-size: 1rem;
  width: fit-content;
}
.totals {
  display: flex;
  gap: 20px;
}
</style>
